import { render, staticRenderFns } from "./dept-detail.vue?vue&type=template&id=8ce90c20&scoped=true&"
import script from "./dept-detail.vue?vue&type=script&lang=js&"
export * from "./dept-detail.vue?vue&type=script&lang=js&"
import style0 from "./dept-detail.vue?vue&type=style&index=0&id=8ce90c20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce90c20",
  null
  
)

component.options.__file = "dept-detail.vue"
export default component.exports